import BaseJoi from 'joi';
import extension from 'joi-date-extensions';

const Joi = BaseJoi.extend(extension);

export default Joi.object({
	dateOfBorn: Joi.date()
		.format(['DD.MM.YYYY', 'D.M.YYYY', 'D.MM.YYYY', 'DD.M.YYYY'])
		.error(() => ({
			message: 'Datum narození musí být ve formátu DD.MM.RRRR (např. 12.11.1982)!',
		})),
	gender: Joi.number()
		.integer()
		.positive()
		.min(1)
		.max(2),
	children: Joi.number()
		.integer()
		.min(0)
		.max(4),
});
